// pt-PT formatting helpers (always Europe/Lisbon, 24 h).
const TZ = "Europe/Lisbon";

export function greeting() {
  const h = new Date().getHours();
  return h >= 6 && h < 12 ? "Bom dia" : h >= 12 && h < 20 ? "Boa tarde" : "Boa noite";
}

export function fmtClock(sec) {
  if (!Number.isFinite(sec)) sec = 0;
  return `${Math.floor(sec / 60)}:${String(Math.floor(sec % 60)).padStart(2, "0")}`;
}

export function fmtDateLong(iso) {
  const d = new Date(iso);
  const date = d.toLocaleDateString("pt-PT", { weekday: "long", day: "numeric", month: "long", timeZone: TZ });
  return date.charAt(0).toUpperCase() + date.slice(1);
}

export function fmtTime(iso) {
  return new Date(iso).toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: TZ });
}

export function fmtDateShort(iso) {
  return new Date(iso).toLocaleDateString("pt-PT", { day: "numeric", month: "short", timeZone: TZ }).toUpperCase();
}

/** Wall-clock parts of an instant in Lisbon: { date: "AAAA-MM-DD", time: "HH:MM" }. */
export function lisbonParts(iso) {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${p.hour}:${p.minute}` };
}

/** Lisbon wall-clock date + time → UTC Date (handles summer/winter time). */
export function fromLisbon(date, time) {
  const guess = new Date(`${date}T${time}:00Z`);
  const shown = lisbonParts(guess.toISOString());
  const drift = new Date(`${shown.date}T${shown.time}:00Z`) - guess;
  return new Date(guess.getTime() - drift);
}

/** DD/MM/AAAA HH:MM (Europe/Lisbon, 24 h). */
export function fmtDateTime(iso) {
  const d = new Date(iso);
  return `${d.toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: TZ })} ${fmtTime(iso)}`;
}

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
}
